import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-stone-100 flex flex-col items-center justify-center px-6 text-center">
      <h1 className="text-6xl md:text-8xl font-bold text-gray-900 mb-4">404</h1>
      <div className="w-12 h-0.5 bg-gray-400 mx-auto mb-6" />
      <p className="text-lg md:text-xl text-gray-600 mb-8">Página no encontrada</p>
      <Link
        to="/"
        className="px-8 py-3 border border-gray-400 text-gray-900 text-sm tracking-widest uppercase transition-all duration-300 hover:bg-gray-900 hover:text-white hover:border-gray-900"
      >
        Volver al Inicio
      </Link>
    </div>
  );
}